import { Button, Stack, Tooltip } from '@mui/material';
import { channelIcons } from 'domains/campaigns/pages/CurationsPage/utils';
import { CampaignChannelLabels, CampaignChannels } from 'domains/campaigns/types';
import PageHeader from 'domains/core/components/PageHeader';

type Props = {
    channel: CampaignChannels;
    onEdit: () => void;
    onExit: () => void;
    /** When false, Edit is hidden (e.g. missing `content.manage`). */
    showEditButton?: boolean;
    isEditDisabled?: boolean;
};

const ContentViewScreenHeader = ({ channel, onEdit, onExit, showEditButton = true, isEditDisabled = false }: Props) => {
    const ChannelIcon = channelIcons[channel];

    const editButton = (
        <Button
            variant="text"
            onClick={onEdit}
            disabled={isEditDisabled}
            data-testid="content-view-edit-button"
            role="button"
        >
            Edit
        </Button>
    );

    return (
        <PageHeader
            icon={<ChannelIcon fontSize="inherit" />}
            header={CampaignChannelLabels[channel]}
            headerOthers={
                <Stack direction="row" columnGap={1} ml={1} justifyContent="flex-end" width="100%">
                    {showEditButton &&
                        (isEditDisabled ? (
                            <Tooltip title="This content is being used in a live campaign and can't be edited.">
                                <span>{editButton}</span>
                            </Tooltip>
                        ) : (
                            editButton
                        ))}
                    <Button variant="outlined" onClick={onExit} data-testid="content-view-exit-button" role="button">
                        Exit
                    </Button>
                </Stack>
            }
        />
    );
};

export default ContentViewScreenHeader;
